import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Link} from "react-router-dom";
import StaffReportOverview from "./Staff/Overview";
import StaffReportEfficiency from "./Staff/Efficiency";

const tab = [
    {
        key: "overview",
        title: "TỔNG QUAN",
    },
    {
        key: "efficiency",
        title: "HIỆU SUẤT",
    }
];

const StaffReport = () => {
    const [currentTab, setCurrentTab] = React.useState("overview");
    const renderTab = () => {
        switch (currentTab) {
            case "overview":
                return <StaffReportOverview />;
            case "efficiency":
                return <StaffReportEfficiency />;
            default:
                return <StaffReportOverview />;
        }
    }

    return (
        <React.Fragment>
            <div className="position-relative">
                <div className="py-3 position-sticky top-3125-rem z-2 bg-white border-top">
                    <div className="container">
                        <div className="row g-1 align-items-center rtl-flex-d-row-r">
                            <div className="col-12">
                                <Swiper
                                    loop={false}
                                    slidesPerView={2.5}
                                    spaceBetween={5}
                                    className="order-catagories owl-carousel py-1"
                                    slideToClickedSlide={true}
                                >
                                    {tab.map((item, i) => (
                                        <SwiperSlide
                                            key={i}
                                            className={currentTab === item.key ? "active" : ""}
                                        >
                                            <Link
                                                className="shadow-sm"
                                                to="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setCurrentTab(item.key);
                                                }}
                                            >
                                                {item.title}
                                            </Link>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-3">
                    <div className="container">
                        <div className="content">
                            {renderTab()}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default StaffReport;
